import gql from 'graphql-tag'
export default gql`mutation deleteFamilyMutation($familyId: Int!) {
  deleteFamily(familyId: $familyId) {
    success
  }
}`